import React from 'react';
import PropTypes from 'prop-types';

import { StyledButton } from './MobileFilterToggleStyles';

var MobileFilterToggle = function MobileFilterToggle(_ref) {
  var onClick = _ref.onClick,
      activeFilterCount = _ref.activeFilterCount;
  return React.createElement(
    StyledButton,
    { onClick: onClick },
    'Filter',
    activeFilterCount > 0 && React.createElement(
      'span',
      null,
      ' (',
      activeFilterCount,
      ')'
    )
  );
};

MobileFilterToggle.propTypes = {
  onClick: PropTypes.func.isRequired,
  activeFilterCount: PropTypes.number.isRequired
};

export default MobileFilterToggle;